import { useMemo } from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useMakeOffersFilter } from '@occc-app/offerHelpers/hooks/use-make-offers-filter.hook';

import { ConfigureForm } from './ConfigureForm';
import { getTransformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import { ConfigureFormInitialValues, ConfigureFormValues } from '../../types';
import {
  useOfferReturnDefaultStrategy,
  useOfferReturnStrategy,
} from '../../../../Chain/hooks/useOfferReturnStrategy';

export const RewardConfigureFormContainer = (props: FormContainerProps) => {
  const offerReturnStrategy = useOfferReturnStrategy();
  const offerReturnDefaultStrategy = useOfferReturnDefaultStrategy();
  const transformOfferToInitialValues = useMemo(
    () => getTransformOfferToInitialValues({ offerReturnStrategy, offerReturnDefaultStrategy }),
    [offerReturnStrategy, offerReturnDefaultStrategy],
  );
  const configureProps = useGetConfigureFormProps<ConfigureFormValues, ConfigureFormInitialValues>(
    props,
    transformOfferToInitialValues,
    getConfigureFormOperations,
  );

  const makeOffersFilter = useMakeOffersFilter();

  return <ConfigureForm {...configureProps} makeOffersFilter={makeOffersFilter} />;
};
